import { Component, OnInit } from '@angular/core';
import {EsBsModalService} from "../../services/bsModalService/bs-modal.service";
import {CookieService} from "../../services/coockieService/coockie.service";
import {UiAdapterService} from "../../services/uiAdapterService/ui-adapter.service";

@Component({
  selector: 'app-nearmap-limit',
  templateUrl: './nearmap-limit.component.html',
  styleUrls: ['./nearmap-limit.component.scss']
})
export class NearmapLimitComponent implements OnInit {

  public Yiit = Yiit;
  public modalMessage = window['NEARMAP_LIMIT_EXCEEDED_MESSAGE'];

  ngOnInit() {
    this.modalService.modalUpdated.subscribe((event)=>{
      if (this.modalService.currentModal == '.nearmap-limit'){
        if (event == 'opened'){
        }
        if (event == 'closed'){
        }
      }
    })
  }

  constructor(private modalService: EsBsModalService, private cookieService: CookieService, private ui: UiAdapterService) { }

}
